"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Wrapper = exports.AvatarWrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _framerMotion = require("framer-motion");

var AvatarWrapper = (0, _styled.default)(_framerMotion.motion.div)(function (_ref) {
  var colors = _ref.theme.colors;
  return {
    cursor: 'pointer',
    color: colors.primary,
    borderRadius: '50%'
  };
});
exports.AvatarWrapper = AvatarWrapper;
var Wrapper = (0, _styled.default)(_framerMotion.motion.div)(function (_ref2) {
  var space = _ref2.theme.space;
  return {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    padding: "0 ".concat(space.large),
    height: '100%'
  };
});
exports.Wrapper = Wrapper;
var _default = Wrapper;
exports.default = _default;